import NutritionalStats from './NutritionalStats';

export default NutritionalStats;
